import { createApiSlice } from "@common";
import {
  CRUD_LEAD_TAGGING,
  CRUD_LEAD_TAGGING_ID,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addLeadTagging",
    method: "post",
    url: CRUD_LEAD_TAGGING,
    stateKey: "message",
  },
  {
    name: "getLeadTaggingById",
    method: "get",
    url: CRUD_LEAD_TAGGING_ID,
    stateKey: "data",
  }
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "leadTagging",
  apiConfig,
  customReducers,
);
const leadTaggingSlice = slice;

// Export the slice's reducer
export default leadTaggingSlice.reducer;

// Export thunks
export const {
  addLeadTagging,
  getLeadTaggingById,
} = thunks;

// Export actions
export const { rowSelect } = actions;
